import { token, url } from 'settings/custom/build'

export default class GameModel {
  constructor() {
    this._params = new URLSearchParams(window.location.search)
    this._requestAgainAllowed = false
    this._blockGameOnError = true
    this._isFinishedContext = true
    this._showBonusPopupContinue = false
    this._token1 = this._params.get('token') || token
    this._retryRequestDelay = this._params.get('retryRequestDelay') || 20000
    this._gameServer = this._params.get('gameserver') || false
    this._url1 =
      this._params.get('gameserver') ||
      this._params.get('beUrl') ||
      this._params.get('be_url') ||
      url
    this._home = this._params.get('homeUrl') || ''
    this._action = this._params.get('action') || ''
    this._mode = this._params.get('mode') || ''
    this._mock = this._params.get('mock') || false
    this._deposit = this._params.get('depositUrl') || ''
    this._lang = this._params.get('lang') || 'en'
    this._platform = this._params.get('platform') || 'desktop'
    this._m = this._params.get('m') || 'a'
    this._options = {
      i18n: this._params.get('lang') || 'en',
      gametype: '',
      rtp: 0,
    }
    this._currency = 'USD'
    const clientHistoryURL =
      this._params.get('historyClientUrl') ||
      'https://history-1.casino.dev.int.rndhub.tech'
    const backHistoryURL =
      this._params.get('historyUrl') ||
      'https://1.casino.dev.int.rndhub.tech/be/history'
    this._history = this.generateHistory(
      clientHistoryURL,
      backHistoryURL,
      this._token1,
      this._lang,
    )
  }

  generateHistory(url, backUrl, token, i18n) {
    return `${url}/?token=${token}&historyUrl=${backUrl}&i18n=${i18n}`
  }

  get isFinishedContext() {
    return this._isFinishedContext
  }

  set isFinishedContext(value) {
    this._isFinishedContext = value
  }

  get showBonusPopupContinue() {
    return this._showBonusPopupContinue
  }

  set showBonusPopupContinue(value) {
    this._showBonusPopupContinue = value
  }

  get requestAgainAllowed() {
    return this._requestAgainAllowed
  }

  set requestAgainAllowed(value) {
    this._requestAgainAllowed = value
  }

  get deposit() {
    return this._deposit
  }

  get mock() {
    return this._mock
  }

  get history() {
    return this._history
  }

  get blockGameOnError() {
    return this._blockGameOnError
  }

  set blockGameOnError(value) {
    this._blockGameOnError = value
  }

  get lang() {
    return this._lang
  }

  get currency() {
    return this._currency
  }

  set currency(value) {
    this._currency = value
  }

  get m() {
    return this._m
  }

  get platform() {
    return this._platform
  }

  get action() {
    return this._action
  }

  get retryRequestDelay() {
    return this._retryRequestDelay
  }

  get mode() {
    return this._mode
  }

  get gameServer() {
    return this._gameServer
  }

  get home() {
    return this._home
  }

  get URL() {
    return this._url1
  }

  get token() {
    return this._token1
  }

  set I18n(value) {
    this._options.i18n = this._options.i18n || value
  }

  get I18n() {
    return this._options.i18n
  }

  set gameType(value) {
    this._options.gametype = value
  }

  get gameType() {
    return this._options.gametype
  }

  set RTP(value) {
    this._options.rtp = value
  }

  get RTP() {
    return this._options.rtp
  }
}

// https://de2.betinvest.me/bigames/aztec/?token=7596180d00697b6a49fb12a4e137ce49&clientId=58&mode=real&gameId=28&homeUrl=https://de1.betinvest.me/casino/crazy-guys-games/all/&depositUrl=https://de1.betinvest.me/casino/bets/?deposit=will&m=a&historyClientUrl=https://history-de2.betinvest.me&historyUrl=https://de2.betinvest.me/bigames/cg-history&gameserver=https://de2.betinvest.me/bigames/cg-gw01/v2
